import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { toggleStockItemSelect } from '../../app/Search/actions/SearchActions';
import { StockItem } from '../../common/types/StockItemTypes';

import './CheckboxWrapper.less';

interface Props {
  checked: boolean;
  stockItem: StockItem;
  children?: React.ReactNode;
  dispatch: Dispatch;
}

class CheckboxWrapper extends Component<Props> {
  render() {
    return (
      <div
        className={
          this.props.checked ? 'checkboxWrapper--checked' : 'checkboxWrapper'
        }
      >
        <div
          role="button"
          tabIndex={0}
          className="checkboxWrapper-cornerBox"
          onClick={this.toggleCheckHandler()}
          onKeyDown={this.toggleCheckHandler()}
        >
          {this.renderCheckBox()}
        </div>
        {this.props.children}
      </div>
    );
  }

  renderCheckBox() {
    if (this.props.checked) {
      return (
        <img
          className="checkboxWrapper-checked"
          src={
            __ASSETS_COMMON_IMAGES_URL__ + '/member/folders/circle-w-check.svg'
          }
          alt="Checked"
          width={20}
          height={20}
        />
      );
    }

    return (
      <img
        className="checkboxWrapper-unchecked"
        src={__ASSETS_COMMON_IMAGES_URL__ + '/member/folders/circle.svg'}
        alt="Unchecked"
        width={20}
        height={20}
      />
    );
  }

  toggleCheckHandler() {
    return () => {
      this.props.dispatch(toggleStockItemSelect(this.props));
    };
  }
}

export default connect()(CheckboxWrapper);
